import app from 'flarum/forum/app';

/** Absolute URL on the main portal; the base is an admin setting, so production can change it. */
export function portalUrl(path) {
  if (path === void 0) {
    path = '/';
  }
  const base = (app.forum.attribute('tarotportalPortalUrl') || '').replace(/\/+$/, '');
  return base + path;
}

/** Forum home ("/" shows the sections page via the default_route setting). */
export function forumHome() {
  return (app.forum.attribute('basePath') || '') + '/';
}
flarum.reg.add('tarotportal-theme', 'forum/utils/portal', { portalUrl: portalUrl,forumHome: forumHome, });